// src/services/storageService.js
import { storage } from '@/firebase/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export async function uploadBlobToStorage(blob, path, metadata = {}) {
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, blob, {
    cacheControl: 'public,max-age=31536000,immutable',
    contentType: blob.type || 'image/webp',
    ...metadata,
  });
  const downloadURL = await getDownloadURL(fileRef);
  return { downloadURL, fullPath: fileRef.fullPath };
}
